<script>
  import { _ } from 'svelte-i18n';

  export let justified;
  export let prevFn;
  export let nextFn;
</script>

<div class="class-step w-full h-full flex-none overflow-y-scroll">

  <div class="flex flex-col items-center w-full min-h-[82%]" class:justify-center={justified}>
    <slot> {$_('base.loading')} </slot>
  </div>

  <div class="flex justify-between w-11/12 mb-4 mx-auto sticky bottom-16 z-10">
    <div class="w-24 cursor-pointer text-center" on:click={prevFn} class:invisible={!prevFn}>
      <button class="btn btn-circle inline">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto fill-current" viewBox="0 0 512 512"><path d="m211.55 431.63c6.1012 6.537 14.672 10.314 23.678 10.314 17.868 0 32.394-14.527 32.394-32.394v-83.818h139.46c25.712 0 46.485-20.773 46.485-46.485v-46.485c0-25.712-20.773-46.485-46.485-46.485h-139.46v-83.818c0-17.868-14.527-32.394-32.394-32.394-9.0065 0-17.577 3.7769-23.678 10.314l-145.12 155.58c-5.0843 5.5201-7.9896 12.638-7.9896 20.047 0 7.4086 2.9053 14.672 7.9896 20.047z"/></svg>
      </button>
      <span class="block font-bold text-xs uppercase"> {$_('base.previous')} </span>
    </div>

    <div class="w-24 cursor-pointer text-center" on:click={nextFn} class:invisible={!nextFn}>
      <button class="btn btn-circle inline">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto fill-current" viewBox="0 0 512 512"><path d="m300.45 80.374c-6.1012-6.537-14.672-10.314-23.678-10.314-17.868 0-32.394 14.527-32.394 32.394v83.818h-139.46c-25.712 0-46.485 20.773-46.485 46.485v46.485c0 25.712 20.773 46.485 46.485 46.485h139.46v83.818c0 17.868 14.527 32.394 32.394 32.394 9.0065 0 17.577-3.7769 23.678-10.314l145.12-155.58c5.0843-5.5201 7.9896-12.638 7.9896-20.047s-2.9053-14.672-7.9896-20.047z"/></svg>
      </button>
      <span class="block font-bold text-xs uppercase"> {$_('base.next')} </span>
    </div>
  </div>
</div>
